module.exports = __webpack_public_path__ + "img/betsize_btn.89a0a6a5.png";